import React from 'react';
import Input from '../form/Input.jsx';
import Select from '../form/Select.jsx';
import Checkbox from '../form/Checkbox.jsx';
import {default as provinces} from '../../provinces.js';

const countries = [
    {
        name: 'United States',
        short: 'US'
    },
    {
        name: 'Canada',
        short: 'CA'
    }
];

class AddressForm extends React.Component {
    static defaultProps = {
        onAddressChange: () => {},
        address: {
            street: [],
            region: '',
            city: '',
            postcode: ''
        }
    }

    constructor () {
        super();
        this.createObject = this.createObject.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.focus = this.focus.bind(this);
        this.inputs = {};
    }

    validate (focus = false) {
        let invalid = Object.keys(this.inputs).filter((key) => {
            let input = this.inputs[key];
            return input && !input.validate();
        });
        if (invalid.length && focus) {
            let firstKey = invalid[0];
            this.inputs[firstKey].focus();
            return;
        }
        return (!invalid.length);
    }

    focus () {
        if (this.validate(true)) {
            return;
        }
        this.inputs[Object.keys(this.inputs)[0]].focus();
    }

    createObject () {
        let street = [this.inputs.street_1.getValue()];

        if (this.inputs.street_2.getValue()) {
            street.push(this.inputs.street_2.getValue());
        }

        let data = {
            to: this.inputs.to.getValue(),
            street: [...street],
            city: this.inputs.city.getValue(),
            region: `${this.inputs.region.getValue()}`,
            postal_code: this.inputs.postcode.getValue(),
            country: this.inputs.region.getValue().substring(0, 2)
        };

        if (this.props.flags) {
            data.primary_billing = this._primary_billing.isChecked();
            data.primary_shipping = this._primary_shipping.isChecked();
        }

        return data;
    }

    handleChange (e) {
        return this.props.onAddressChange(this.createObject());
    }

    render () {
        let {address} = this.props;
        return (
            <div>
                <Input ref={ref => (this.inputs.to = ref)} label="Branch or Library Name" name="to" id="to" value={address.to} required />
                <Input ref={ref => (this.inputs.street_1 = ref)} className="spaced-half" label="Street Address" type="text" name="street[]" id="street_1" value={address.street[0]} placeholder="Street and number" required collapse />
                <Input ref={ref => (this.inputs.street_2 = ref)} label="Address 2" type="text" name="street[]" id="street_2" value={address.street[1]} placeholder="Suite, unit, building, floor, etc." hideLabel />

                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <Input ref={ref => (this.inputs.city = ref)} label="City" type="text" name="city" id="city" required value={address.city} />
                    </div>

                    <div className="col-xs-12 col-sm-4">
                        <Select label="State/Province" ref={ref => (this.inputs.region = ref)} id="region" value={address.region} required onChange={this.handleChange}>
                            <option value="">Please select region, state or province</option>
                            {countries.map(con => {
                                return (<optgroup key={con.short} label={con.name}>
                                    {provinces.filter(prov => prov.country === con.short).map(prov => (
                                        <option key={`${prov.country}-${prov.short}`} value={`${prov.country}-${prov.short}`}>{prov.name}</option>
                                    ))}
                                </optgroup>);
                            })}
                        </Select>
                    </div>

                    <div className="col-xs-12 col-sm-4">
                        <Input label="Zip/Postal Code" ref={ref => (this.inputs.postcode = ref)} type="text" name="postcode" id="zip" required value={address.postal_code} />
                    </div>

                </div>

                {this.props.priceNote ? <div className="alert">
                    <small>PLEASE NOTE: Pricing will reflect the standard currency for the country your organization is located in. For questions or changes please contact <a href="mailto:customerservice@findaway.com">customerservice@findaway.com</a>.</small>
                </div> : null}

                {this.props.flags ? <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <Checkbox ref={ref => (this._primary_billing = ref)} label="Primary Billing?" checked={address.primary_billing} id="primary_billing" />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <Checkbox ref={ref => (this._primary_shipping = ref)} label="Primary Shipping?" checked={address.primary_shipping} id="primary_shipping" />
                    </div>
                </div> : null}
            </div>
        );
    }
}

export default AddressForm;
